import React from 'react'
import PropTypes from 'prop-types'
import DOMPurify from 'dompurify'
import { Box } from '@material-ui/core'
import { LoadingFeedback, NoData2 } from 'components'

import { useStyles } from './styles'

const CookiePolicyViewer = ({ cookiePolicy, isLoading = false }) => {
  const classes = useStyles()

  if (isLoading) {
    return <LoadingFeedback open={isLoading} />
  }

  if (!cookiePolicy) {
    return <NoData2 title="Nenhuma política de cookies foi encontrada." />
  }

  return (
    <Box p={2}>
      {cookiePolicy.content && (
        <Box className={classes.policyContainer}>
          <Box
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(cookiePolicy.content),
            }}
          />
        </Box>
      )}
    </Box>
  )
}

CookiePolicyViewer.propTypes = {
  cookiePolicy: PropTypes.object,
  isLoading: PropTypes.bool,
}

export default CookiePolicyViewer
